import { ClbDrawer } from "@celebration/react/ClbDrawer/ClbDrawer";
import type { ClbDrawerProps } from "@celebration/react/ClbDrawer/ClbDrawer.types";
import type { DrawerProps } from "@components/contracts/Drawer.types";
import type React from "react";
import { useEffect } from "react";

export const CelebrationDrawer: React.FC<DrawerProps> = ({
  children,
  isOpen,
  onClose,
  ...props
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.stopImmediatePropagation();
        onClose?.();
      }
    };

    const handleMouseDown = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (target.closest(".clb-drawer")) return;
      if (target.closest(".clb-drawer-overlay")) onClose?.();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [isOpen, onClose]);

  return (
    <ClbDrawer
      {...props}
      buttonsFooter={
        props.buttonsFooter as unknown as ClbDrawerProps["buttonsFooter"]
      }
      isOpen={isOpen}
      onClose={onClose}
    >
      {children}
    </ClbDrawer>
  );
};
